import { useTheme } from "@mui/material";
const useGetCurrentColor = (variant, color, parentBG) => {
  const theme = useTheme();
  const palette = theme.palette[parentBG];
  switch (variant) {
    case "primary":
      return {
        backgroundColor: palette.brandBackground,
        textColor: palette.brandContrast
      };
    case "secondary":
      return {
        backgroundColor: palette.transparent,
        textColor: palette[`${color}Content`]
      };
    case "color":
      return {
        backgroundColor: palette[`${color}Background`],
        textColor: palette[`${color}Contrast`]
      };
    case "disabled":
      return {
        backgroundColor: palette.disable,
        textColor: palette.disableText
      };
  }
};
export {
  useGetCurrentColor
};
